<template>
  <b-modal id="new-voucher" size="lg" title="Add New Voucher">
    <div id="add-new-voucher" class="modal-form">
      <b-row no-gutters>
        <b-col sm="12" md="3">
          <h6 class="main-label">Voucher</h6>
        </b-col>
        <b-col>
          <b-form-group
            id="nameGroup"
            label="Name"
            label-for="name"
            class="secondary-label mb-3"
            :invalid-feedback="errorMessage('name')"
            :state="isValid('name')"
          >
            <b-form-input id="name" type="text" v-model="form.name" required maxlength="25"></b-form-input>
          </b-form-group>
          <b-form-group
            id="descriptionGroup"
            :label="'Description ' + descriptionLabel"
            label-for="description"
            class="secondary-label mb-2"
            :invalid-feedback="errorMessage('description')"
            :state="isValid('description')"
          >
            <b-form-textarea
              id="description"
              v-model="form.description"
              placeholder="Enter description"
              :rows="3"
              :maxlength="descriptionMaxLength"
              :max-rows="6"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col>
          <hr class="form-divider" />
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col sm="12" md="3">
          <h6 class="main-label">Type</h6>
        </b-col>
        <b-col>
          <b-form-group id="typeGroup" label-for="type" label="Type" class="secondary-label">
            <b-form-select id="type" v-model="form.type" :options="types"></b-form-select>
          </b-form-group>
          <div id="value-container" v-if="form.type == 'value'">
            <b-form-group id="valueGroup" label="Value" label-for="value" class="secondary-label">
              <b-input-group>
                <b-form-select slot="prepend" :options="valueTypeOptions" v-model="form.valueType"></b-form-select>
                <b-form-input
                  id="value"
                  v-model="form.value"
                  required
                  type="number"
                  min="1"
                  max="10000000000"
                  oninput="this.value = Math.abs(this.value)"
                />
              </b-input-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col>
          <hr class="form-divider" />
        </b-col>
      </b-row>
      <b-row no-gutters class="mb-2">
        <b-col sm="12" md="3">
          <h6 class="main-label">Image</h6>
          <span class="label-helper d-inline-block">(350 x 200)</span>
        </b-col>
        <b-col>
          <div id="voucher-upload-image" class="border" v-b-modal.voucherUploadImage>
            <!-- Use an if else here for showing an image -->
            <img v-if="image !== ''" :src="image" alt="Sample Image" />
            <div class="upload-icon rounded-circle border"></div>
          </div>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col>
          <hr class="form-divider" />
        </b-col>
      </b-row>
      <b-row
        no-gutters
        class="mb-2"
      >
        <b-col sm="12" md="3">
          <h6 class="main-label">Privilege Card Bundle</h6>
        </b-col>
        <b-col>
          <span class="d-block secondary-label mb-2">Privilege Card Bundle Use Only</span>
          <div style="height: 26px;">
            <switches
              v-model="form.forPackage"
              theme="custom"
              color="primary"
              type-bold="true"
              text-enabled="On"
              text-disabled="Off"
              style="top: -18px;"
              @input="changeQuantityValue()"
            ></switches>
          </div>
        </b-col>
      </b-row>
      <b-row class="mb-2" v-if="!form.forPackage">
        <b-col>
          <hr class="form-divider" />
        </b-col>
      </b-row>
      <b-row no-gutters class="mb-2" v-if="!form.forPackage">
        <b-col sm="12" md="3">
          <h6 class="main-label">Redemption</h6>
        </b-col>
        <b-col>
          <div style="height: 26px;">
            <switches
              v-model="form.absolute"
              theme="custom"
              color="primary"
              type-bold="true"
              text-enabled="On"
              text-disabled="Off"
              style="top: -18px;"
            ></switches>
          </div>
          <b-row no-gutters v-if="!form.absolute">
            <b-col cols="4">
              <b-form-group
                id="quantityGroup"
                label="Quantity"
                label-for="Quantity"
                class="secondary-label mb-0 mt-3"
              >
                <b-form-input
                  id="quantity"
                  type="number"
                  v-model="form.quantity"
                  min="1"
                  oninput="this.value = Math.abs(this.value)"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col>
          <hr class="form-divider" />
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col sm="12" md="3">
          <h6 class="main-label">Validity</h6>
        </b-col>
        <b-col>
          <div id="validity-group">
            <b-form-radio-group v-model="form.validityType" class="mb-2">
              <b-form-radio value="1" class="secondary-label" selected>Day</b-form-radio>
              <b-form-radio value="2" class="secondary-label">Date Range</b-form-radio>
              <b-form-radio value="3" class="secondary-label">Birth Month</b-form-radio>
            </b-form-radio-group>
            <b-form-group
              v-if="form.validityType == '1'"
              label="Day(s)"
              label-for="days"
              label-class="secondary-label"
              :invalid-feedback="errorMessage('validity_days')"
              :state="isValid('validity_days')"
            >
              <b-form-checkbox-group
                id="daysGroup"
                v-model="form.validityDays"
                :options="days"
                name="days"
                buttons
              ></b-form-checkbox-group>
            </b-form-group>
            <b-row v-if="form.validityType == '2'">
              <b-col>
                <b-form-group
                  label="Start Date"
                  label-for="start_date"
                  class="secondary-label mb-3 sl-helper"
                  :invalid-feedback="errorMessage('validity_start_date')"
                  :state="isValid('validity_start_date')"
                >
                  <b-input-group class="custom-datepicker mb-3 muli-sb d-flex">
                    <b-input-group-text slot="append" class="bg-transparent">
                      <img
                        src="@/assets/images/icons/calendar.svg"
                        alt="Calendar Icon"
                        class="form-icon action-button"
                        @click="openCalendar('start')"
                      />
                    </b-input-group-text>
                    <SingleDatepicker
                      :bootstrap-styling="true"
                      v-model="form.validityStartDate"
                      ref="datepicker_start"
                      wrapper-class="custom-datepicker"
                      :style="{color: '#2a2a2a !important', width: '124px'}"
                      :disabledDates="disabledDates"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="End Date"
                  label-for="end_date"
                  class="secondary-label mb-3 sl-helper"
                  :invalid-feedback="errorMessage('validity_end_date')"
                  :state="isValid('validity_end_date')"
                >
                  <b-input-group class="custom-datepicker mb-3 muli-sb d-flex">
                    <b-input-group-text slot="append" class="bg-transparent">
                      <img
                        src="@/assets/images/icons/calendar.svg"
                        alt="Calendar Icon"
                        class="form-icon action-button"
                        @click="openCalendar('end')"
                      />
                    </b-input-group-text>
                    <SingleDatepicker
                      :bootstrap-styling="true"
                      v-model="form.validityEndDate"
                      ref="datepicker_end"
                      wrapper-class="custom-datepicker"
                      :style="{color: '#2a2a2a !important', width: '124px'}"
                      :disabledDates="disabledDates"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="form.validityType == '3'">
              <b-col>
                <b-row>
                  <b-col>
                    <b-form-group
                      label="Grace Period Prior to the Start of the Month"
                      class="secondary-label mb-0">
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4" class="pr-0">
                    <b-form-group
                      class="secondary-label"
                      :invalid-feedback="errorMessage('validity_start_grace_period')"
                      :state="isValid('validity_start_grace_period')"
                    >
                      <b-form-input
                        type="number"
                        required
                        v-model="form.validityStartGracePeriod"
                        min="1" oninput="this.value = Math.abs(this.value)"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-text id="password-help-block" style="margin-top: 12px; color: #000000 !important;">
                      Day/s
                    </b-form-text>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group
                      label="Grace Period After the End of the Month"
                      class="secondary-label mb-0">
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4" class="pr-0">
                    <b-form-group
                      class="secondary-label"
                      :invalid-feedback="errorMessage('validity_end_grace_period')"
                      :state="isValid('validity_end_grace_period')"
                    >
                      <b-form-input
                        type="number"
                        required
                        v-model="form.validityEndGracePeriod"
                        min="1" oninput="this.value = Math.abs(this.value)"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-text id="password-help-block" style="margin-top: 12px; color: #000000 !important;">
                      Day/s
                    </b-form-text>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <label class="secondary-label mr-2 d-none">Specify Time?</label>
          <div id="specify-time-wrapper" class="d-none">
            <b-form-checkbox name="checkbox-1" value="accepted" unchecked-value="not_accepted">Yes</b-form-checkbox>
          </div>
          <label class="secondary-label mr-2 d-none">Specify Frequency?</label>
          <div id="specify-time-wrapper" class="d-none">
            <b-form-checkbox name="checkbox-1" value="accepted" unchecked-value="not_accepted">Yes</b-form-checkbox>
          </div>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col>
          <hr class="form-divider" />
        </b-col>
      </b-row>
      <b-row no-gutters class="mb-4">
        <b-col sm="12" md="3">
          <h6 class="main-label">Visibility</h6>
        </b-col>
        <b-col>
          <div style="height: 26px;">
            <switches
              v-model="form.visibility"
              theme="custom"
              color="primary"
              type-bold="true"
              text-enabled="On"
              text-disabled="Off"
              style="top: -18px;"
            ></switches>
          </div>
        </b-col>
      </b-row>
    </div>
    <div slot="modal-footer">
      <b-button
        variant="ghost"
        v-bind:disabled="loading"
        class="btn-cancel"
        style="margin-right: .25rem;"
        @click="clearFields"
      >Cancel</b-button>
      <b-button
        variant="primary"
        v-bind:disabled="loading"
        style="margin-left: .25rem;"
        @click="sendForm"
      >
        <template v-if="loading">Saving...</template>
        <template v-else>Save</template>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import Switches from "vue-switches";
import Datepicker from "vue-bulma-datepicker";
import SingleDatepicker from "vuejs-datepicker";

function initialState() {
  return {
    form: {
      name: "",
      description: "",
      type: "item",
      valueType: "PHP",
      value: 1,
      image: "",
      absolute: true,
      quantity: 1,
      validityDays: [],
      forPackage: false,
      validityType: 1,
      visibility: true,
      validityStartDate: new Date(),
      validityEndDate: new Date(),
      validityStartGracePeriod: 1,
      validityEndGracePeriod: 1
    },
    descriptionMaxLength: 300,
    days: [
      { text: "Sun", value: "sun" },
      { text: "Mon", value: "mon" },
      { text: "Tue", value: "tue" },
      { text: "Wed", value: "wed" },
      { text: "Thu", value: "thu" },
      { text: "Fri", value: "fri" },
      { text: "Sat", value: "sat" }
    ],
    disabledDates: {
      to: new Date(Date.now() - 864e5)
    },
    types: [
      { value: "item", text: "Item-Based" },
      { value: "value", text: "Value-Based" }
    ],
    valueTypeOptions: [
      { value: "%", text: "%" },
      { value: "PHP", text: "PHP" }
    ],
    env: process.env.VUE_APP_MODE
  };
}

export default {
  name: "addVoucher",
  props: ["image"],
  data() {
    return initialState();
  },
  components: {
    Switches,
    SingleDatepicker
  },
  computed: {
    ...mapState("vouchers", [
      "vouchers",
      "loading",
      "maxPage",
      "nextPage",
      "prevPage",
      "currentPage",
      "totalPerPage",
      "searching",
      "currentFirstItem",
      "currentLastItem",
      "initialPageCount",
      "errors",
      "editing"
    ]),
    descriptionLabel: {
      get: function() {
        if (this.form.description != null) {
          return (
            this.form.description.length + " / " + this.descriptionMaxLength
          );
        }
        return "0 / " + this.descriptionMaxLength;
      }
    }
  },
  methods: {
    async getVouchers(page) {
      let param = {
        page: page,
        payload: this.searchPayload
      };
      await this.$store.dispatch("vouchers/getVouchers", param);
    },
    async sendForm() {
      this.$store.dispatch("vouchers/resetErrors");

      let param = {
        name: this.form.name,
        description: this.form.description,
        type: this.form.type,
        value_type: this.form.valueType,
        value: this.form.value,
        image: this.image.replace(/^data:image\/\w+;base64,/, ""),
        absolute: this.form.absolute,
        quantity: this.form.quantity,
        validity_type: this.form.validityType,
        validity_days: JSON.stringify(this.form.validityDays),
        validity_start_date: this.$moment(this.form.validityStartDate).format(
          "YYYY-MM-DD"
        ),
        validity_end_date: this.$moment(this.form.validityEndDate).format(
          "YYYY-MM-DD"
        ),
        for_bundle: this.form.forPackage,
        visibility: this.form.visibility,
        validity_start_grace_period: this.form.validityStartGracePeriod,
        validity_end_grace_period: this.form.validityEndGracePeriod
      };

      if (this.form.forPackage) {
        delete param.quantity;
      }

      if (this.form.forPackage) {
        param.absolute = true;
      }

      let _this = this;
      await this.$store
        .dispatch("vouchers/saveVoucher", param)
        .then(function() {
          if (_this.errors == null) {
            _this.clearFields();
            _this.hideModal("new-voucher");
            _this.getVouchers(1);
          }
        });
    },
    clearFields() {
      let initialData = initialState();

      // Iterate through the props
      for (let prop in initialData) {
        // Reset the prop locally.
        this[prop] = initialData[prop];
      }

      this.hideModal("new-voucher");
      this.$store.dispatch("vouchers/resetErrors");

      this.$emit("clearImage", true);
    },
    showModal(modal) {
      this.$root.$emit("bv::show::modal", modal);
    },
    hideModal(modal) {
      this.$root.$emit("bv::hide::modal", modal);
    },
    openCalendar: function(type) {
      let calendar = "datepicker_" + type;
      this.$refs[calendar][0].showCalendar();
    },
    disabledEndDates: function() {
      return {
        to: new Date(this.form.start_date - 8640000)
      };
    },
    changeQuantityValue: function() {
      if (this.form.forPackage) {
        this.form.quantity = null;
        console.log(this.form.quantity);
      } else {
        this.form.quantity = 1;
      }
    },
    errorMessage(field) {
      if (this.errors == null) {
        return "";
      }

      return this.errors.errors[field];
    },
    isValid(field) {
      if (this.errors == null) {
        return false;
      }
      return this.errors.errors[field] ? false : true;
    }
  }
};
</script>
<style lang="scss">
</style>